import { render, staticRenderFns } from "./paymanage.vue?vue&type=template&id=1596ff90&scoped=true&"
import script from "./paymanage.vue?vue&type=script&lang=js&"
export * from "./paymanage.vue?vue&type=script&lang=js&"
import style0 from "./paymanage.vue?vue&type=style&index=0&id=1596ff90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1596ff90",
  null
  
)

export default component.exports